import { isEmpty, omit } from 'remeda';

import { api } from 'v2/api/base';
import { rewardsService } from 'v2/api/rewardsService';
import { MutationArg } from 'v2/types';
import { TournamentGroupForm, TournamentGroupModel } from 'v2/types/TournamentGroupModel';

export const tournamentGroupService = {
  getTournamentGroups(): Promise<TournamentGroupModel[]> {
    return api.get('v1/admin/tournament-groups').json();
  },

  createTournamentGroup(
    _key: string,
    { arg: tournamentGroupForm }: MutationArg<TournamentGroupForm>
  ): Promise<TournamentGroupModel> {
    if (isEmpty(tournamentGroupForm.rewards)) {
      return api.post('v1/admin/tournament-groups', { json: omit(tournamentGroupForm, ['rewards']) }).json();
    } else {
      return rewardsService.createRewards('createRewards', { arg: tournamentGroupForm.rewards }).then((rewardIds) =>
        api
          .post('v1/admin/tournament-groups', {
            json: { ...omit(tournamentGroupForm, ['rewards']), rewardIds },
          })
          .json()
      );
    }
  },

  updateTournamentGroup(
    [_key, tournamentGroup]: [string, TournamentGroupModel],
    { arg: tournamentGroupForm }: MutationArg<TournamentGroupForm>
  ): Promise<TournamentGroupModel> {
    if (isEmpty(tournamentGroup.rewardIds)) {
      return rewardsService.createRewards('createRewards', { arg: tournamentGroupForm.rewards }).then((rewardIds) =>
        api
          .put(`v1/admin/tournament-groups/${tournamentGroup.id}`, {
            json: { ...omit(tournamentGroupForm, ['rewards']), rewardIds },
          })
          .json()
      );
    } else {
      return rewardsService
        .deleteRewards(['deleteRewards', tournamentGroup.rewardIds])
        .then(() => rewardsService.createRewards('createRewards', { arg: tournamentGroupForm.rewards }))
        .then((rewardIds) =>
          api
            .put(`v1/admin/tournament-groups/${tournamentGroup.id}`, {
              json: { ...omit(tournamentGroupForm, ['rewards']), rewardIds },
            })
            .json()
        );
    }
  },
};
